module.exports = __webpack_public_path__ + "static/media/food-chains-in-peril_mobile.4306ff87.jpg";